module.exports = __webpack_public_path__ + "static/media/Hair02.adf0d033.jpeg";